/**
 * @sw-package fundamentals@after-sales
 * @private
 */
Shopware.Component.register('swag-migration-shop-information', () => import('./swag-migration-shop-information'));
Shopware.Component.register('swag-migration-premapping', () => import('./swag-migration-premapping'));
Shopware.Component.register('swag-migration-progress-bar', () => import('./swag-migration-progress-bar'));
Shopware.Component.register('swag-migration-confirm-warning', () => import('./swag-migration-confirm-warning'));
